/**
 * @param {Date|String} value
 * @param {String} count
 * @param {Boolean} wordBoundary
 * @returns {String}
 * @description Formats the string to add ellipsis after certain character count
 */
export function ellipsis(value, count = 225, wordBoundary = false) {
  try {
    if (value && value.length < count) return value

    const shortened = value.substr(0, count)

    return `${
      wordBoundary ? shortened.substr(0, shortened.lastIndexOf(' ')) : shortened
    }...`
  } catch (e) {
    return value
  }
}
